import moment from 'moment';
import { version } from '../../../package.json';
import { purge, putToStorage, getFromStorage } from './localStorageHelper';

const getCurrentVersion = () => {
    const currentDate = moment().format('DD.MM.YYYY');
    return `${version} ${currentDate}`;
};

export const checkVersionChanges = () => {
    const savedVersion = getFromStorage('version');
    const currentVersion = getCurrentVersion();
    if (savedVersion !== currentVersion) {
        purge();
        putToStorage('version', currentVersion);
    }
};



// WEBPACK FOOTER //
// ./src/client/utils/versionHelper.js